import React from 'react';
import Skeleton from 'react-loading-skeleton';
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap';

const TableSkeleton = ({ colCount, rowCount, tableClass, skeletonClass }) => {
  return (
    <Table>
      <thead>
        <tr className='thead-light rounded-2'>
          {[...Array(colCount)].map((_, index) => (
            <th key={'th' + index} className={tableClass}><Skeleton className={skeletonClass}/></th>
          ))}
        </tr>
      </thead>
      <tbody>
        {[...Array(rowCount)].map((_, index) => (
          <tr key={'tr' + index}>
            {[...Array(colCount)].map((_, index) => (
              <td key={'td' + index} className={tableClass}><Skeleton className={skeletonClass} /></td>
            ))}
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

TableSkeleton.propTypes = {
  colCount: PropTypes.number,
  rowCount: PropTypes.number,
  tableClass: PropTypes.string,
  skeletonClass: PropTypes.string
};

export default TableSkeleton;